






























































import {
    Vue,
    Component,
    Prop,
    Mixins
} from 'vue-property-decorator';
import UtilsService from '@/mixins/UtilsService';
import StorageService from '@/mixins/StorageService';

import {
    Action
  } from 'vuex-class';

@Component({
    components: {}
})
export default class ParkingLotView extends Mixins(
    UtilsService,
    StorageService
) {
    @Action('closeDialog', { namespace: 'dialog' }) closeDialog!: any;
    @Action('showAlert', { namespace: 'dialog' }) showAlert!: any;
    @Action('showConfirm', { namespace: 'dialog' }) showConfirm!: any;

    @Prop()
    mapParkingLotList!: any[]; 

    @Prop()
    searchAddrText!: Object; // 현재 지번주소와 도로명주소 표시 텍스트

    constructor() {
        super();
    }

    private beforeCreate(): void {}
    private created(): void {}
    private beforeMount(): void {}
    private mounted(): void {
        this.disabledScroll();
    }
    private beforeUpdate(): void {}
    private updated(): void {}
    private destroyed(): void {
        this.activationScroll();
    }

    /**
     * @method closeparkinglotview
     * @description 인근주차장 리스트 닫기
     */
    closeparkinglotview(): void {
      this.$emit('close');
    }

    /**
     * @method mapClose
     * @description 지도 닫기
     */
    mapClose(): void {
      this.$emit('mapClose');
    }

    /**
     * @method selectParkinglot
     * @description 인근주차장 리스트 클릭시 열리는 showConfirm 
     */
    selectParkinglot(parkinglot: any): void {
        const callback = () => {
            this.$router.replace(`/park-list`);
            this.$nextTick(() => {
                this.$router.push(`/park-detail/${parkinglot.idx}`)
            })
            this.mapClose();
        }

        this.showConfirm({
            message: '주차장 수정 화면으로 이동하시겠습니까? <br> 이전에 입력한 정보들은 모두 삭제됩니다.',
            callbackFn: callback
          });
    }
}
